import gql from 'graphql-tag'
import { QuotaFragment } from '@/graphql/fragments/loans'

export const Fragment = gql`
  ${QuotaFragment}
  fragment QuotaFragment on loans_quota{
    ...Quota
  }
`
